import React from 'react'

export default () => {
  return (
    <footer>
      <div>
        <p><i className="fa fa-copyright" aria-hidden="true"></i> Olivia Carpentier</p>
        <p className="feed">Conception web originale <a href="http://www.feedbydesign.com" target="_blank">Feed by Design</a></p>
      </div>
    </footer>
  )
}



// WEBPACK FOOTER //
// ./src/Footer.js